/**
 * ノードにくっつけて、機能を追加するための基本クラス
 */
export class Behaviour {
    node;
    enabled = true;
    constructor(node) {
        this.node = node;
    }
    get scene() {
        if (!this.node.parent) {
            return this.node;
        }
        let n = this.node.parent;
        while (n.parent) {
            n = n.parent;
        }
        return n;
    }
    dispose() {
        return;
    }
    sendMessage(key, ...arg) {
        this.node.sendMessage(this, key, ...arg);
    }
}
//# sourceMappingURL=Behaviour.js.map